(() => {
  function initialize() {
    document.querySelectorAll('[data-fsc-pair-landing] [data-fs-ad-gallery-panel]').forEach((gallery) => {
      const surface = gallery.querySelector('[data-fs-pdp-gallery-zoom-open]');
      if (!surface || surface.dataset.fscPairSwipeReady === 'true') return;
      surface.dataset.fscPairSwipeReady = 'true';

      const pointers = new Set();
      let gesture = null;
      let suppressClickUntil = 0;

      surface.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch') return;
        pointers.add(event.pointerId);
        // Leave a two-finger gesture to the browser's pinch zoom.
        if (!event.isPrimary || pointers.size !== 1) {
          gesture = null;
          suppressClickUntil = Date.now() + 700;
          return;
        }
        suppressClickUntil = 0;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, vertical: false };
      }, { passive: true });

      surface.addEventListener('pointermove', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = Math.abs(event.clientX - gesture.x);
        const dy = Math.abs(event.clientY - gesture.y);
        // A scroll that later curves sideways must not change the product photo.
        if (dy >= 12 && dy > dx * 1.3) gesture.vertical = true;
      }, { passive: true });

      surface.addEventListener('pointerup', (event) => {
        pointers.delete(event.pointerId);
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        const vertical = gesture.vertical;
        gesture = null;
        if (vertical || Math.abs(dx) < 12 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;

        // Short horizontal drags should not accidentally open the zoom dialog.
        suppressClickUntil = Date.now() + 700;
        if (Math.abs(dx) < 40) return;
        const control = gallery.querySelector(dx < 0 ? '[data-fs-pdp-gallery-next]' : '[data-fs-pdp-gallery-prev]');
        if (!control) return;
        // The existing controller owns image, zoom, thumbnail, count and wrapping.
        control.setAttribute('data-fs-pdp-gallery-swipe', '');
        try { control.click(); }
        finally { control.removeAttribute('data-fs-pdp-gallery-swipe'); }
      }, { passive: true });

      surface.addEventListener('pointercancel', (event) => {
        pointers.delete(event.pointerId);
        gesture = null;
      }, { passive: true });

      surface.addEventListener('click', (event) => {
        // Keyboard activation has detail 0 and must keep opening the zoom dialog.
        if (event.detail !== 0 && Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
